import { render, staticRenderFns } from "./repaymentDetail.vue?vue&type=template&id=56b280f5&scoped=true"
import script from "./repaymentDetail.vue?vue&type=script&lang=js"
export * from "./repaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./repaymentDetail.vue?vue&type=style&index=0&id=56b280f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b280f5",
  null
  
)

export default component.exports